import { useUser } from "./UserProvider";
import AddIcon from '@mui/icons-material/Add';
import NotesIcon from '@mui/icons-material/Notes';
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EditProfileDialog from "./EditProfileDialog";
import { useState } from "react";
import {ProjectHeader} from "./NavMenu";
import './styles/ChatNavbar.css';

export function ChatNavbar({selected}) {
    return (
        <div className="chat-navbar">
            <div className="nav-section">
                <ProjectHeader/>
            </div>
            <div className="nav-section">
                {/* <Write isSelected={selected === "write"} />
                <Inspiration isSelected={selected === "search"}/>
                <ContentCalendar isSelected={selected === "content-calendar"}/> */}
            </div>
            <div className="nav-section nav-section-right">
                <Profile/>
                {/* <Settings isSelected={selected === "settings"}/> */}
            </div>
        </div>
    )
}

function Profile() {
    const {userInfo, setUserInfo} = useUser();
    const [showEditProfileDialog, setShowEditProfileDialog] = useState(false);
    
    return (
        <>
        <div className="profile-container" onClick={() => setShowEditProfileDialog("profile")}>
            <img 
                src={userInfo?.info?.profile_pic_cropped || "/images/avatar.jpg"} 
                alt="Profile" 
                className="profile-image"
            />
            <EditProfileDialog 
                smallScreen={false} 
                userInfo={userInfo} 
                setUserInfo={setUserInfo} 
                dialog={showEditProfileDialog} 
                onClose={() => setShowEditProfileDialog(false)} 
                onSave={(data) => console.log(data)} 
                user={userInfo} 
                setDialog={setShowEditProfileDialog}
            />
        </div>
        </>
    )
}

function Write({isSelected}) {
    const navigate = useNavigate();
    return (
        <Button 
            disableRipple 
            className={`nav-button ${isSelected ? 'selected' : ''}`}
            onClick={() => navigate("/chat")}
        >
            <AddIcon/>
            <div >Write</div>
        </Button>
    )
}

function ContentCalendar({isSelected}) {
    const navigate = useNavigate();
    return (
        <Button 
            disableRipple 
            className={`nav-button ${isSelected ? 'selected' : ''}`}
            onClick={() => navigate("/content-calendar")}
        >
            <CalendarMonthIcon/>
            <div>Calendar</div>
        </Button>
    )
}

function Inspiration({isSelected}) {
    const navigate = useNavigate();
    return (
        <Button 
            disableRipple 
            className={`nav-button ${isSelected ? 'selected' : ''}`}
            onClick={() => navigate("/search")}
        >
            <NotesIcon/>
            <div>Inspiration</div>
        </Button>
    )
}

function Settings({isSelected}) {
    const navigate = useNavigate();
    return (
        <Button 
            disableRipple 
            className="publish-btn"
            onClick={() => navigate("#")}
        >
            <div>Publish</div>
        </Button>
    )
}